import { all } from 'redux-saga/effects';

import commonSagas from 'us.common/sagas'
import Collection from 'us.collection'

let sagas = [
  ...commonSagas,
  ...Collection.Sagas
];

function* rootSaga() {
  yield all(sagas);
}

export default rootSaga;